import * as types from './constants';

export const getAiChatTokenRequest = data => ({
  type: types.GET_AI_CHAT_TOKEN_REQUEST,
  payload: data || {}
});

export const getAiChatTokenDone = data => ({
  type: types.GET_AI_CHAT_TOKEN_DONE,
  payload: data
});

export const getAiChatTokenFailed = errors => ({
  type: types.GET_AI_CHAT_TOKEN_FAILED,
  payload: errors
});

export const clearAiChatToken = () => ({
  type: types.CLEAR_AI_CHAT_TOKEN
});
